import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const COOKIE_STORAGE_KEY = 'studio_pastore_cookie_consent';

/**
 * Tracks SPA route changes and sends page_view events to Google Analytics 4
 * ONLY if the user has granted analytics consent via the CookieBanner (GDPR).
 *
 * Works in tandem with Google Consent Mode v2 declared in public/index.html:
 * - Default consent is 'denied' — gtag will queue but not send hits.
 * - When the user accepts, CookieBanner calls gtag('consent','update', {granted})
 *   and dispatches a 'cookieConsentUpdated' event.
 */
const hasAnalyticsConsent = () => {
  try {
    const stored = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (!stored) return false;
    const parsed = JSON.parse(stored);
    return parsed && parsed.analytics === true;
  } catch (e) {
    return false;
  }
};

const AnalyticsTracker = () => {
  const location = useLocation();
  const consentRef = useRef(hasAnalyticsConsent());

  // Listen for consent updates fired by CookieBanner
  useEffect(() => {
    const handler = (e) => {
      consentRef.current = !!(e.detail && e.detail.analytics);
    };
    window.addEventListener('cookieConsentUpdated', handler);
    return () => window.removeEventListener('cookieConsentUpdated', handler);
  }, []);

  useEffect(() => {
    if (!consentRef.current) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
